<template>
  <div>
    <div class="grey-text">
      <b-form-group :class="{ 'form-group--error': $v.user.email.$error }">
          <mdb-input icon="envelope" id="email" label="User email" type="email"
                     v-model.trim="$v.user.email.$model"/>
          <div v-if="$v.user.email.$dirty">
            <div class="error" v-if="!$v.user.email.required">Field is required</div>
            <div class="error" v-if="!$v.user.email.email">Email mismatch. Example johndoe123@icipe.org</div>
          </div>
      </b-form-group>
    </div>
    <div class="d-flex justify-content-end">
      <mdb-btn class="my-0" outline="black" size="md" type="submit" @click="returnUserEmail">Search
        <i aria-hidden="true" class="fas fa-search"></i></mdb-btn>
    </div>
  </div>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import {mdbBtn, mdbInput} from "mdbvue";
import EventBus from "@/components/EventBus";

export default {
  name: "UserSearchTextInput", components: {mdbInput, mdbBtn},
  data(){
    return {
     user:{
       email: null
     },
    }
  },
  validations: {
    user: {
      email: {required, email}
    }
  },
  methods: {
    returnUserEmail(){
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      EventBus.$emit('user-email', this.user.email)
    }
  }
}
</script>
